import { render } from "./Modal.vue?vue&type=template&id=32035e92&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=32035e92&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32035e92"]])

export default __exports__